import { createEpicFromAsyncAction, createEpicFromAsyncActionEmptyRequest } from '../../../utils';
import { pricePrgError } from '../../ui/redux/uiSlices';
import { fetchActivityLogs, fetchLoggableActionTypes } from './activityLogSlices';

const fetchActivityLogs$ = createEpicFromAsyncAction(
    fetchActivityLogs,
    (req, { activityLogClient }) =>
        activityLogClient.search(
            req.searchString,
            req.pageIndex,
            req.pageSize,
            req.sortColumn,
            req.sortOrder
        ),
    undefined,
    (_, err) => [fetchActivityLogs.failure(err), pricePrgError(err)]
);

const fetchLoggableActionTypes$ = createEpicFromAsyncActionEmptyRequest(
    fetchLoggableActionTypes,
    ({ activityLogClient }) => activityLogClient.getLoggableActionTypes()
);

export default [fetchActivityLogs$, fetchLoggableActionTypes$];
